import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css';
import styles from './UserActionButton.module.scss';
import cn from 'classnames';
import { useConversation } from '@chewy/chat-library-common';
import ChatButton from './ChatButton';
import { getIconByActionType, handleActions, UserActionDef } from '@chewy/chat-library-common';
import { first } from 'lodash';

export interface UserActionButtonProps {
    /** The message to display in the button */
    message?: string;
    /** Click handler for the button */
    onClick?: () => void;
    /** Widget data from the registry (contains message and action) */
    data?: UserActionDef[];
    icon?: React.ReactNode;
    className?: string;
}

export default function UserActionButton({
    message = 'Get help from our care team',
    onClick,
    data,
    icon,
    className,
}: UserActionButtonProps) {
    const { submitQuestion } = useConversation();
    const defaultAction = first(data)?.defaultAction;
    const isShowSeparator = first(data)?.showSeparator === true;

    // Use message from data prop if available, otherwise fall back to message prop or default
    const displayMessage = defaultAction?.text ?? message;
    const effectiveIcon = icon ?? getIconByActionType(defaultAction?.payload?.action);


    const handleClick = () => {
        // If action is provided, use handleActions
        if (defaultAction) {
            // call handleActions with the first item in the data array
            handleActions(defaultAction, first(data));
        } else if (submitQuestion && displayMessage) {
            // Fall back to submitQuestion if no action
            submitQuestion(displayMessage);
        }

        // Also call onClick callback if provided
        if (onClick) {
            onClick();
        }
    };

    return (
        <>
            {isShowSeparator && (
                <div className={styles.agentOrDivider}>
                    <span className={styles.agentOrLine} aria-hidden="true" />
                    <span className={styles.agentOrText}>or</span>
                    <span className={styles.agentOrLine} aria-hidden="true" />
                </div>
            )}
            <ChatButton
              className={cn(styles.userActionButton, className)}
              onClick={handleClick}
              icon={effectiveIcon}
              buttonText={displayMessage}
            />
        </>
    );
}
